<template>
  <div
      v-loading="reqloading"
      element-loading-text="玩命加载中……"
      element-loading-spinner="el-icon-loading">
    <div class="addCustom h-100 container">
      <div class="content">
        <div class="formCon">
          <div class="title"><span class="dot"></span>我的客户</div>
          <el-form :model="addCustom" class="form" :rules="rules" ref="ruleForm" label-width="100px" size="mini">
            <div>
              <!-- 客户 -->
              <div class="card-title">客户信息</div>
              <div style="width: 95%;margin: 0 auto">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="客户名称" prop="customer_name">
                      <el-input placeholder="请输入内容" v-model="addCustom.customer_name" class="input-with-select"
                                disabled>
                        <el-link slot="append" :underline="false" @click="showCustomerDialog" v-if="type === 'add'">
                          <i class="el-icon-edit"></i>选择客户
                        </el-link>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="客户性质" prop="nature">
                      <el-select class="el-input-c" v-model="addCustom.nature" placeholder="请选择客户性质">
                        <el-option v-for="nature in natures" :key="nature" :label="nature"
                                   :value="natures[nature]"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="代理品牌">
                      <store-customer-brands :prop-brands="addCustom.brand" @change="brandChange"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="销售" prop="sale_id">
                      <label slot="label">销&emsp;&emsp;售</label>
                      <span>{{ addCustom.sale || '--' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="客户级别" prop="grade">
                      <el-select class="el-input-c" v-model="addCustom.grade" placeholder="请选择客户级别">
                        <el-option v-for="grade in grades" :key="grade" :label="grade"
                                   :value="grades[grade]"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="客户行业" prop="type">
                      <el-input disabled v-model="addCustom.trades"/>
                    </el-form-item>
                  </el-col>

                </el-row>
              </div>
            </div>
            <div style="margin-bottom: 15px;">
              <!-- 联系人信息 -->
              <div class="card-title">联系人信息&emsp;
                <el-button size="mini" class="btn-operation btn-pink-border el-button--default"
                           style="font-size: 12px" @click="addContact">新增联系人
                </el-button>
              </div>
              <div v-for="(contact,index) in addCustom.customer_contacts" :key="index" class="form-card"
                   style="margin-bottom: 10px;position:relative;">
                <i v-if="index" class="el-icon-error contact-delete"
                   @click="deleteContact(index)"></i>
                <div class="contact-title">联系人{{ index + 1 }}</div>
                <div style="padding: 0 10px">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="联系人姓名" :rules="rules.contact_name"
                                    :prop="'customer_contacts.' + index + '.contact_name'">
                        <el-input class="el-input-c" v-model="contact.contact_name"
                                  placeholder="请输入联系人姓名"
                                  maxlength="32" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="职位" :rules="rules.contact_position"
                                    :prop="'customer_contacts.' + index + '.contact_position'">
                        <el-input class="el-input-c" v-model="contact.contact_position"
                                  placeholder="请输入联系人职位"
                                  maxlength="32" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="联系电话" :rules="rules.contact_phone"
                                    :prop="'customer_contacts.' + index + '.contact_phone'">
                        <el-input class="el-input-c" v-model="contact.contact_phone"
                                  placeholder="请输入联系电话"
                                  maxlength="32" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="微信" :rules="rules.contact_wx"
                                    :prop="'customer_contacts.' + index + '.contact_wx'">
                        <el-input class="el-input-c" v-model="contact.contact_wx"
                                  placeholder="请输入微信"
                                  maxlength="32" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="省/市/区">
                        <el-cascader class="el-input-c" size="mini" :options="options"
                                     v-model="contact.provinces"
                                     clearable
                                     @change="handleRegionContactChange($event,index)"></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="详细地址"
                                    :prop="'customer_contacts.' + index + '.contact_address'">
                        <el-input class="el-input-c" v-model="contact.contact_address"
                                  placeholder="请输入详细地址"
                                  maxlength="128" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div>
              <!-- 开票信息 -->
              <div class="card-title">开票信息
                <el-link type="primary" icon="el-icon-s-promotion" @click="showHistoryTitle">历史开票信息</el-link>
              </div>
              <div class="form-card" style="margin-bottom: 10px">
                <div style="padding: 0 10px">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="发票抬头" prop="invoice_title">
                        <el-input class="el-input-c" v-model="addCustom.invoice_title"
                                  placeholder="请输入发票抬头"
                                  maxlength="128" show-word-limit/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="税号" prop="tax_id">
                        <el-input class="el-input-c" v-model="addCustom.tax_id" placeholder="请输入税号"
                                  maxlength="64" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="客户电话">
                        <el-input class="el-input-c" v-model="addCustom.telephone"
                                  placeholder="请输入客户电话"
                                  maxlength="20" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="省/市/区">
                        <el-cascader class="el-input-c" size="mini" :options="options"
                                     v-model="selectedOptions" clearable
                                     @change="handleRegionChange"></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="详细地址">
                        <el-input class="el-input-c" v-model="addCustom.address"
                                  placeholder="请输入详细地址"
                                  maxlength="128" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="开户行">
                        <el-input class="el-input-c" v-model="addCustom.bank_name"
                                  placeholder="请输入开户行"
                                  maxlength="128" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="银行卡号">
                        <el-input class="el-input-c" v-model="addCustom.bank_amount"
                                  placeholder="请输入银行卡号"
                                  maxlength="64" show-word-limit></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="发票类型">
                        <el-select class="el-input-c" v-model="addCustom.invoice_type" clearable
                                   placeholder="请选择发票类型">
                          <el-option label="电子专票" value="spe_invoice"></el-option>
                          <el-option label="电子普票" value="common_invoice"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="发票内容" prop="invoice_content">
                        <el-select class="el-input-c" v-model="addCustom.invoice_content" clearable
                                   placeholder="请选择发票内容">
                          <!-- TODO: 发票内容选项 -->
                          <el-option
                              v-for="(val, key) in invoice_content"
                              :key="key + 'invoice_content'"
                              :label="key" :value="val"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="邮箱地址" prop="invoice_email">
                        <el-input class="el-input-c" v-model="addCustom.invoice_email"
                                  placeholder="请输入接收发票邮箱地址"
                                  maxlength="64" show-word-limit/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <el-row v-if="type == 'edit' && addCustom.follow_record.length">
              <div class="title"><span class="dot"></span>客户跟进记录</div>
              <el-col :span="24">
                <el-form-item label="">
                  <el-timeline>
                    <el-timeline-item
                        v-for="item in addCustom.follow_record"
                        placement="top"
                        :key="item.id"
                        class="timestamp"
                        color="#3296FF"
                        :timestamp="item.follow_timestamp">
                      <div>记录人：{{ item.creator }}</div>
                      <div>跟进记录：{{ item.record_content }}</div>
                    </el-timeline-item>
                  </el-timeline>

                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="height: 100px"/>
        </div>
        <el-row class="formCon-buttons">
          <el-col :push="5" :span="12">
            <el-button class="btn-operation-sub btn-pink" @click="onSubmit('ruleForm')"
                       v-if="userAuth.can_update_customer_info" :loading="onSubmitLoading"
                       :disabled="onSubmitLoading">
              {{ type === 'edit' ? '保存' : '添加' }}
            </el-button>
            &nbsp;
            &nbsp;
            &nbsp;
            &nbsp;
            <el-button class="btn-operation-sub btn-pink-border" @click="goBack">取消</el-button>
          </el-col>
          <el-col :push="6" :span="6" style="text-align: right;padding-right: 10px">
            <el-button class="btn-operation-sub btn-pink-border btn-pink" @click="goNewAdd" v-if="type === 'edit'">
              添加客户
            </el-button>
          </el-col>
        </el-row>
      </div>

<!--      客户选择-->
      <el-dialog
          title="可选客户"
          :visible.sync="dialogCustomer"
          width="1000px"
          center>
        <!--      客户选择-->
        <customer-select @selectRow="selectTheCustomer"></customer-select>
        <!--      销售选择-->
        <el-dialog
            width="600px"
            :title="selectSaleTitle"
            :visible.sync="innerVisible"
            append-to-body>
          <el-form :model="selectData" status-icon size="small" label-width="100px" :inline="false">
            <el-form-item label="客户名称：">
              {{ selectData.customer_name }}
              <el-tag v-if="selectData.year_frame === 'Y'" type="danger" size="mini">年框</el-tag>
              <el-tag v-else type="info" size="mini">非年框</el-tag>
            </el-form-item>
            <el-form-item label="关联销售：" prop="pass">
              <el-select class="el-input-c" v-model="selectData.sale_id" placeholder="请选择（可选）销售" clearable
                         filterable>
                <el-option v-for="item in saleOptions" :key="item.id" :label="item.name"
                           :value="item.id">{{ item.name }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selectSale" :loading="loadingSure" :disabled="loadingSure"
                         v-if="canAdd">确认
              </el-button>
              <el-button type="info" disabled v-else>该客户已绑定销售，无权限再绑定销售</el-button>

              <el-tooltip class="item" effect="dark" :content="selectSaleTip" placement="top">
                <el-button type="text"><i class="el-icon-info"></i></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="已绑定销售：" v-if="saleBindOptions.length>0">
              <el-tag v-for="(saleInfo,index) in saleBindOptions" :key="index" type="success" effect="plain"
                      style="margin-right: 5px" size="mini">{{ saleInfo.sale }}
              </el-tag>
            </el-form-item>
          </el-form>

        </el-dialog>
      </el-dialog>

      <!--      公司历史抬头-->
      <CompanyTitle :visible.sync="dialogHistoryTitle" :customer-id="addCustom.customer_id"
                    @handleSelect="handleSelectTitle"/>
    </div>
  </div>

</template>
<script>
import {regionData, CodeToText, TextToCode} from 'element-china-area-data'
import {
  getCustomerSaleDetail,
  checkOkCustomerSales,
  addOrEditSaleCustom,
  getSaleOption,
  deleteSaleCustomContract, getCustomerSaleOption
} from '@/api/customers'
import {getOptionItems} from '@/api/option'
import StoreCustomerBrands from "./components/StoreCustomerBrands.vue";
import CustomerSelect from "@/components/customer/CustomerSelect";
import CompanyTitle from "@/views/custom/components/CompanyTitle";


function AddCustomOption(params) {
  let _obj = Object.assign({}, params)
  const _fromat = {}
  const _mapping = {}
  const fromatFunc = (taget, fromatFuncMap, mapping) => {
    this.defaultVal = []
    this.fromatFuncMap = fromatFuncMap
    Object.keys(taget).forEach((key) => {
      this[key] = taget[key]
      if (!fromatFuncMap[key]) {
        this.defaultVal.push(key)
      }
      if (mapping[key]) {
        mapping[key].call(this, taget[key])
      }
    })
  }

  fromatFunc(_obj, _fromat, _mapping)
  this.getValue = () => {
    let _pushObject = {}
    Object.keys(this.fromatFuncMap).forEach((key) => {
      this[key] = this.fromatFuncMap[key](this) || this[key]
    })
    this.defaultVal.forEach((key) => {
      _pushObject[key] = this[key]
    })
    return _pushObject
  }
}

const rules = {
  customer_name: [{required: true, message: '请选择客户', trigger: 'change'},],
  nature: [{required: true, message: '请选择客户性质', trigger: 'change'},],
  grade: [{required: true, message: '请选择客户级别', trigger: 'change'},],
  contact_name: [{required: true, message: '请输入联系人姓名', trigger: 'blur'},],
  contact_position: [{required: true, message: '请输入联系人职位', trigger: 'blur'},],
  contact_phone: [{required: true, message: '请输入联系电话', trigger: 'blur'},],
  contact_wx: [{required: true, message: '请输入微信', trigger: 'blur'},],
  invoice_email: [
    {required: true, message: '请输入接收邮箱', trigger: 'blur'},
    {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
  ],
  invoice_title: [{required: true, message: '请输入发票抬头', trigger: 'blur'},],
  tax_id: [{required: true, message: '请输入税号', trigger: 'blur'},],
  invoice_content: [{required: true, message: '发票内容', trigger: ['blur', 'change']},],
  sale_id: [{required: true, message: '请选择客户', trigger: 'change'},]
}

export default {
  name: 'addCustom',
  components: {
    CompanyTitle,
    StoreCustomerBrands,
    CustomerSelect
  },
  data() {
    return {
      rules,
      reqloading: false,
      dialogCustomer: false,
      innerVisible: false,
      selectSaleTitle: '请选择客户对应的销售',
      selectData: {customer_id: null, customer_name: '', sale_id: null, sale: '', year_frame: 'N'},
      selectSaleTip: '',
      loadingSure: false,
      onSubmitLoading: false,
      dialogBasicCusStoreBool: false,
      type: 'add', //add or edit or child
      addCustom: new AddCustomOption({
        id: null,
        sale: '', //销售
        sale_id: null,
        old_sale_id: 0,
        customer_name: '', //客户姓名
        customer_id: null, //客户姓名
        nature: '', //客户性质
        grade: '', //客户级别
        type: '', //客户类型
        trades: '',// 客户行业 根据订单统计
        brand: [], //代理品牌
        viewBrand: '',
        link_man: '', //联系人
        contact_way: '', //联系方式
        post: '', //职位
        invoice_title: '', //发票抬头
        tax_id: '', //	税号
        telephone: '', //电话
        address: '', //地址
        bank_name: '',//开户行
        bank_amount: '', //银行账号
        invoice_type: '',//发票类型
        invoice_content: '',//发票内容
        invoice_email: '',//接收邮箱
        province: '',
        city: '',
        area: '',
        customer_contacts: [{
          contact_name: '',
          contact_position: '',
          contact_phone: '',
          contact_wx: '',
          contact_address: '',
          provinces: []
        }],
        follow_record: []
      }),
      basicCusForm: {name: ''},
      dialogTableVisible: false,
      options: regionData,
      selectedOptions: [],
      customerOptions: [],
      customerTimestamp: false,
      optionsItem: ['customer_types', 'customer_grades', 'customer_natures', 'invoice'],
      grades: {},
      natures: {},
      types: {},
      invoice_content: {},
      saleOptions: [], //销售下拉框
      saleBindOptions: [], //已绑定客户的想销售下拉框
      dialogHistoryTitle: false,
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    user() {
      return this.$store.getters.user
    },
    canAdd() {
      return this.saleBindOptions.length === 0 || this.userAuth.can_bind_multiple_sale;
    }
  },
  created() {
    this.init()
    this.getOptions(this.optionsItem)
  },
  methods: {
    init() {

      if (this.$route.params.id) {
        this.getCustomDetail(this.$route.params.id)
        this.type = 'edit'
      } else {
        this.type = 'add'
      }
    },
    getSaleOption() {
      // :disabled="!userAuth.can_create_other_customer" ??权限
      if (!this.userAuth.can_create_other_customer) {
        this.selectSaleTip = '没有选择其他销售的权限，只能选自己';
        let userCache = localStorage.getItem('user')
        if (userCache) {
          let user = JSON.parse(userCache)
          if (!user.value) {
            return
          }
          let userId = user.value.id
          let userName = user.value.name
          // 没有选择其他销售的权限，即销售指南选自己
          this.saleOptions = []
          this.saleOptions.push({id: userId, name: userName})
          this.selectData.sale = userName
          this.selectData.sale_id = userId
        }
      } else {
        this.selectSaleTip = '可任意选择销售';
        // 可选的销售
        getSaleOption('Sale').then(res => {
          this.saleOptions = res.model.role
        })
      }

    },
    onSubmit(formName) {
      let that = this
      this.onSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _form = {...this.addCustom.getValue()}

          addOrEditSaleCustom(_form).then((res) => {
            let row = res.model;
            this.showToast({
              h: that
            })
            this.jumpToDetail(row.id)
          })
        } else {
          return false;
        }
      });
      setTimeout(() => {
        this.onSubmitLoading = false
      }, 1500)
    },
    jumpToDetail(id) {
      const routeUrl = this.$router.resolve({
        name: 'editCustom',
        params: {id: id}
      })
      window.open(routeUrl.href, '_self')
    },
    //显示开票信息的省市区组件
    showTitlePCA(data) {
      this.selectedOptions = []
      if (TextToCode[data.province]) {
        this.selectedOptions.push(TextToCode[data.province].code)
        if (TextToCode[data.province][data.city]) {
          this.selectedOptions.push(TextToCode[data.province][data.city].code)
          if (TextToCode[data.province][data.city][data.area]) {
            this.selectedOptions.push(TextToCode[data.province][data.city][data.area].code)
          }
        }
      }
    },
    //详情
    getCustomDetail(id) {
      this.reqloading = true
      getCustomerSaleDetail({id: id}).then(res => {
        this.reqloading = false
        let obj = res.model
        this.addCustom = new AddCustomOption(obj)
        const data = res.model
        this.showTitlePCA(data)
        // if (data.province && data.city && data.area) {
        //   this.selectedOptions = [TextToCode[data.province].code, TextToCode[data.province][data.city].code, TextToCode[data.province][data.city][data.area].code]
        // }
        if (Array.isArray(data.customer_contacts)) {
          data.customer_contacts.forEach(el => {
            if (el.contact_province && el.contact_city && el.contact_area) {
              this.$set(el, 'provinces', [TextToCode[el.contact_province].code, TextToCode[el.contact_province][el.contact_city].code, TextToCode[el.contact_province][el.contact_city][el.contact_area].code])
            }
          });
        }
      })
    },
    //选项配置
    getOptions(options) {
      getOptionItems(options).then(res => {
        this.grades = res.model.customer_grades || {}
        this.natures = res.model.customer_natures || {}
        this.types = res.model.customer_types || {}
        this.invoice_content = res.model.invoice || {}
      })
    },
    goBack() {
      this.$router.back()
    },
    goNewAdd() {
      const {href} = this.$router.resolve({
        name: `addCustom`
      });
      window.open(href, "_self");
      this.$router.replace({
        name: `addCustom`
      });
    },
    handleRegionChange(e) {
      this.addCustom.province = CodeToText[e[0]]
      this.addCustom.city = CodeToText[e[1]]
      this.addCustom.area = CodeToText[e[2]]
    },
    handleRegionContactChange(e, index) {
      this.addCustom.customer_contacts[index].contact_province = CodeToText[e[0]]
      this.addCustom.customer_contacts[index].contact_city = CodeToText[e[1]]
      this.addCustom.customer_contacts[index].contact_area = CodeToText[e[2]]
    },
    brandChange(val) {
      this.addCustom.brand = val
    },
    // 新增联系人
    addContact() {
      const obj = {
        contact_name: '',
        contact_position: '',
        contact_phone: '',
        contact_wx: '',
        contact_address: '',
        provinces: []
      }
      this.addCustom.customer_contacts.push(obj);
    },
    //删除联系人信息
    deleteContact(index) {
      //删除客户联系人
      let customer_contact = this.addCustom.customer_contacts[index]
      if (customer_contact) {
        if (customer_contact.id) {
          let contact_name = customer_contact.contact_name;
          this.$msgbox.confirm('此操作将永久删除客户联系人【' + contact_name + '】信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteSaleCustomContract({id: customer_contact.id}).then(() => {
              this.addCustom.customer_contacts.splice(index, 1)
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });

        } else
          this.addCustom.customer_contacts.splice(index, 1)
      }

    },
    selectSale() {
      this.loadingSure = true
      let id = this.selectData.sale_id
      let sale = this.saleOptions.find((sale) => {
        return sale.id == id
      })
      this.selectData.sale = sale.name
      //后端校验客户和销售是否已建立关系
      checkOkCustomerSales({sale_id: this.selectData.sale_id, customer_id: this.selectData.customer_id})
          .then((res) => {
            this.loadingSure = false
            if (res.success && res.model) {
              this.dealErrorSale(res)
            } else {
              this.$message.warning("客户和销售已绑定")
            }
          });

    },
    dealErrorSale(res) {
      if (res.model.is_ok) {
        this.innerVisible = false
        this.dialogCustomer = false
        this.confirmCustomerSale(this.selectData)
      } else {
        if (res.model.exist_id) {
          this.$msgbox.confirm('该销售已和客户已绑定，是否查询详情?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.jumpToDetail(res.model.exist_id)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else
          this.$message.warning("客户和销售已绑定")
      }
    },
    confirmCustomerSale(data) {
      //确认 [客户]和【销售】
      this.addCustom.customer_id = data.customer_id
      this.addCustom.customer_name = data.customer_name
      this.addCustom.sale = data.sale
      this.addCustom.sale_id = data.sale_id
    },
    showCustomerDialog() {
      this.dialogCustomer = true
    },
    selectTheCustomer(row) {
      this.selectData.customer_name = row.name
      this.selectData.customer_id = row.id
      this.selectData.year_frame = row.year_frame
      // this.dialogCustomer = false

      this.selectSaleTitle = '请确认客户对应的销售';
      this.innerVisible = true
      // :disabled="!userAuth.can_create_other_customer"
      this.$nextTick(() => {
        this.getCustomerSaleOption()
        this.getSaleOption()
      })

    },
    async getCustomerSaleOption() {
      await getCustomerSaleOption({customer_id: this.selectData.customer_id})
          .then((res) => {
            this.$nextTick(() => {
              this.saleBindOptions = res.model || []
            })
          })
    },
    showHistoryTitle() {
      this.dialogHistoryTitle = true
    },
    handleSelectTitle(row) {
      Object.assign(this.addCustom, row)
      // console.log(this.addCustom)
      this.showTitlePCA(row)
      this.dialogHistoryTitle = false
    }
  }
}
</script>
<style scoped>
.addCustom {
  min-width: 1200px;
}

.title {
  color: #323232;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  margin-bottom: 20px;
}

.dot {
  width: 8px;
  height: 8px;
  background: rgba(224, 63, 61, 1);
  border-radius: 2px;
  display: inline-block;
  margin-right: 5px;
}

.content {
  background: #fff;
  padding: 24px 30px 0;
}

.formCon {
  position: relative;
  width: 95%;
  margin: 0 auto;
}

div.el-input-c {
  width: 100%;
}

.formCon-buttons {
  left: 5%;
  bottom: 2px;
  /*width: 100%;*/
  /* background-color: antiquewhite; */
  box-shadow: -1px -4px 9px 0px rgba(195, 195, 195, 0.8);
  background: #fff;
  padding: 8px 10px;
  z-index: 1;
  position: fixed;
  /*position: absolute;*/
  /*position: relative;*/
  width: 90%;
  margin: 0 auto;
  border-radius: 2px;
  text-align: center;
}
</style>
<style>
.el-form-item div.el-form-item__content {
  text-align: left;
}

div.el-dialog {
  width: 40%;
}

.timestamp .el-timeline-item__timestamp {
  font-size: 14px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
}

.timestamp .el-timeline-item__content {
  font-size: 14px;
  font-weight: 400;
  color: rgba(149, 149, 149, 1);
}

.timestamp div.el-timeline-item__tail {
  border-left: 2px solid #3296Ff;
}

.timestamp div.el-timeline-item__node--normal {
  background: #fff !important;
  border: 1px solid #3296Ff;
  width: 8px;
  height: 8px;
  left: 0;
}

.contact-title {
  position: relative;
  padding-left: 25px;
  margin-bottom: 15px;
  color: rgba(50, 50, 50, 1);
  line-height: 12px;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
}

.contact-title::after {
  content: " ";
  position: absolute;
  bottom: 2px;
  left: calc(25px - 8px - 6px);
  width: 8px;
  height: 8px;
  background: rgba(224, 63, 61, 1);
  border-radius: 50%;
}

.contact-delete {
  cursor: pointer;
  font-size: 28px;
  position: absolute;
  top: -10px;
  right: -10px;
  color: rgba(46, 46, 46, 0.67);
}

.btn-operation-sub {
  border-radius: 2px;
  font-size: 14px;
  padding: 12px 20px;
}
</style>
